module.exports = __webpack_public_path__ + "static/media/ic-arrow-up-white.206c2de6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-arrow-up-white.svg
// module id = 598
// module chunks = 14